import { computed } from 'vue';

import { translate } from '@/shared/i18n';
import { ConnectionStatus, useConnectionStatus } from '@/shared/lib';

const useConnectionStatusBanner = () => {
  const { status, hasWebSocketConnected } = useConnectionStatus();
  const isVisible = computed<boolean>(
    () =>
      status.value === ConnectionStatus.OFFLINE ||
      (status.value === ConnectionStatus.RECONNECTING && hasWebSocketConnected.value),
  );
  const label = computed<string>(() => translate(`connection.${status.value}`));

  return { status, isVisible, label };
};

export { useConnectionStatusBanner };
